import { getUser } from "constants/apiUrls";
import { useAuth } from "hooks/useAuth";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { http } from "middleware/apiMiddleware";
import { Loader } from "components/Common/Loader";
import { routes } from "constants/routes";

const VerifyAuth = () => {
  const { token, businessId } = useParams();
  const decoded: any = jwtDecode(token || "");
  const authContext = useAuth();
  const fetchUserDetails = async () => {
    try {
      localStorage.setItem("token", JSON.stringify(token));
      const { data, error } = await http.get(getUser(decoded["user_id"]));
      const payload = { data: { access: token, ...data } };
      authContext?.login(payload, `${routes.chooseBusiness}/${businessId}`);
    } catch (error) {
      console.error("error occured while fetching user details");
    }
  };

  useEffect(() => {
    fetchUserDetails();
  }, []);

  return (
    <div className="flex justify-center item-center h-screen mt-[200px]">
      <Loader color="darkBlue" />
      {/* {isFetching && <>Loading...</>}
      {!!error && <>Failed to fetch user</>} */}
    </div>
  );
};

export default VerifyAuth;
